// @flow
import * as React from 'react';
import SquareProductGroupCollage from 'app/common/react/components/profile/ProductGroupCard/SquareProductGroupCollage';
import Truncater from 'app/packages/truncater';
import WideProductGroupCollage from 'app/common/react/components/profile/ProductGroupCard/WideProductGroupCollage';
import { Box, Card, Text } from 'gestalt';

type Props = {|
  layout?: 'square' | 'wide',
  productGroup: Object,
|};

// Used to allow for 2x the line height when text size is xl
const DEFAULT_DESCRIPTION_HEIGHT = 70;

export default function ProductGroupCard({ layout, productGroup }: Props) {
  let productGroupCollage;

  if (!productGroup) {
    return null;
  }
  if (layout === 'square') {
    productGroupCollage = <SquareProductGroupCollage pins={productGroup.preview_pins} />;
  } else if (layout === 'wide') {
    productGroupCollage = (
      <WideProductGroupCollage
        height={200}
        numCols={3}
        pins={productGroup.preview_pins}
        width={300}
      />
    );
  } else {
    return null;
  }

  return (
    <Card>
      <Box data-test-id={`productGroup-${productGroup.name}`}>
        <Box position="relative">{productGroupCollage}</Box>
        <Box display="flex" alignItems="end" paddingY={1}>
          <Box padding={2} flex="grow" overflow="hidden">
            <Text size="xl" weight="bold">
              <Truncater maxHeightPx={DEFAULT_DESCRIPTION_HEIGHT}>{productGroup.name}</Truncater>
            </Text>
          </Box>
        </Box>
      </Box>
    </Card>
  );
}
